var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-card p-6"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Email Settings"}},[_c('Email')],1),_c('vs-tab',{attrs:{"label":"Template Catogary"}},[_c('Catogary')],1),_c('vs-tab',{attrs:{"label":"Template"}},[_c('Template')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }